<template>
    <div class="form-group mb-3">
      <label :for="'output' + inputID" class="text-label">
        {{ outputLabel }}{{ noColon ? '' : ':' }}&nbsp;
      </label>
      <input
        :value="prefix + val"
        disabled
        class="calc-input-width me-1"
        :id="'output' + inputID"
      /> 
      {{ unit }}
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  //import newId from '../../utils/unique_key';
  
  export default {
    name: 'FreeOutput',
    props: {
      outputLabel: {
        type: String,
        required: true,
        default: ''
      },
      val: {
        required: true,
        default: 0
      },
      unit: {
        type: String,
        default: ''
      },
      noColon: {
        type: Boolean,
        default: false
      },
      prefix: {
        type: String,
        default: ''
      }
    },
    setup() {
      //const inputID = newId();
      const inputID = ref(Math.random().toString(36).substr(2, 9)); // Temporary solution for unique ID
      return { inputID };
    }
  };
  </script>
  